import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import { useEffect } from "react";

export const BookingDurationForm = ({ formData = {}, validation = {} }) => {
  const { rootFormDetails, setRootFormDetails } = formData;

  const {
    control,
    formState: { errors },
    trigger,
    setValue,
  } = validation;

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const durationOptions = [
    { name: "Mins", id: "MINUTES" },
    { name: "Hrs", id: "HOURS" },
    { name: "Days", id: "DAYS" },
  ];

  useEffect(() => {
    setValue("setup_duration", rootFormDetails?.setup_duration);
    setValue("booking_config", rootFormDetails?.booking_config);
  }, [rootFormDetails?.setup_duration, rootFormDetails?.booking_config]);

  return (
    <section
      className={`${globalStyles.cardWithBorder} light-bg`}
      style={{ gap: "20px" }}
    >
      <div className={`${globalStyles.cardWithBorder} white`}>
        <h6 className="mb-0">Duration & Booking Limit</h6>
        <p className="small-text-size">
          Setup the length of your service & how many people can book per
          minutes, hours or days.
        </p>

        <div
          className={`${globalStyles.cardWithBorder} flex-column flex-md-row align-items-center mt-4`}
          style={{ columnGap: "20px", rowGap: "50px" }}
        >
          <primaryComponents.PercentageInputFieldV2
            control={control}
            isRequired
            name={"lenght_of_service"}
            label="Length of service"
            percentLabel={
              <div style={{ width: "100px" }}>
                <primaryComponents.SelectField
                  classNames={"selectPropMid"}
                  floatError={false}
                  value={
                    durationOptions?.find(
                      (durationOption) =>
                        durationOption?.id ===
                        rootFormDetails?.booking_config?.duration_unit,
                    )?.name || "Mins"
                  }
                  options={durationOptions}
                  nameKey={"name"}
                  idKey={"id"}
                  onChange={(value) => {
                    const bookingConfig = {
                      ...rootFormDetails?.booking_config,
                    };
                    bookingConfig.duration_unit = value;
                    setRootFormDetails((prevState) => ({
                      ...prevState,
                      booking_config: bookingConfig,
                    }));
                  }}
                />
              </div>
            }
            percentBg={"#e4dafc"}
            percentColor={"#7647ee"}
            classNames="white"
            placeholder="Enter Value"
            type="number"
            step={0.01}
            min={0.01}
            value={rootFormDetails?.booking_config?.duration_value}
            errorMessage={errors?.booking_config?.duration_value}
            onKeyUp={() =>
              errors?.booking_config?.duration_value &&
              trigger("booking_config.duration_value")
            }
            onChange={({ target: { value } }) => {
              const bookingConfig = { ...rootFormDetails?.booking_config };
              bookingConfig.duration_value = value;
              setRootFormDetails((prevState) => ({
                ...prevState,
                booking_config: bookingConfig,
              }));
            }}
          />
          <span
            className={`${globalStyles.statusBlock} font-weight-bold d-md-block d-none`}
            style={{ minWidth: "50px", fontStyle: "italic" }}
          >
            Per
          </span>
          <primaryComponents.InputFieldV2
            control={control}
            isRequired
            name={"slot_per_booking"}
            label={
              "How many slot/booking(s) can you accommodate within selected timeframe?"
            }
            value={rootFormDetails?.booking_config?.capacity}
            classNames="white"
            placeholder="Enter Value"
            type="number"
            step={1}
            min={0}
            floatError={false}
            errorMessage={errors?.booking_config?.capacity}
            onKeyUp={() =>
              errors?.booking_config?.capacity &&
              trigger("booking_config.capacity")
            }
            onChange={({ target: { value } }) => {
              const bookingConfig = { ...rootFormDetails?.booking_config };
              bookingConfig.capacity = value;
              setRootFormDetails((prevState) => ({
                ...prevState,
                booking_config: bookingConfig,
              }));
            }}
          />
        </div>
      </div>
      <div className={`${globalStyles.cardWithBorder} white`}>
        <h6 className="mb-0">Availability</h6>
        <p className="small-text-size">
          Setup the days and time you will be available to take customers
        </p>
        <div
          className={`${globalStyles.cardWithBorder} mt-4`}
          style={{ gap: "20px" }}
        >
          <p className="dark--text">Select Day</p>
          <div className={styles.daysCover}>
            {days?.map((day, index) => (
              <span
                key={index}
                className={`${globalStyles.statusBlock} ${styles.daysCover__item}`}
              >
                <label className="cursor-pointer" htmlFor={`dayOfWeek${index}`}>
                  {day}
                </label>
                <primaryComponents.Checkbox
                  className="mb-1"
                  name="dayOfWeek"
                  id={`dayOfWeek${index}`}
                  isChecked={rootFormDetails?.booking_config?.availability_slots?.day_of_week?.includes(
                    index,
                  )}
                  onChange={() => {
                    const bookingConfig = {
                      ...rootFormDetails?.booking_config,
                    };
                    const dayOfWeek =
                      bookingConfig.availability_slots.day_of_week;

                    if (dayOfWeek.includes(index)) {
                      const position = dayOfWeek.indexOf(index);
                      dayOfWeek.splice(position, 1);
                    } else dayOfWeek.push(index);

                    bookingConfig.availability_slots.day_of_week = dayOfWeek;
                    setRootFormDetails((prevState) => ({
                      ...prevState,
                      booking_config: bookingConfig,
                    }));
                  }}
                />
              </span>
            ))}
          </div>
        </div>

        <div
          className={`${globalStyles.cardWithBorder} flex-column flex-md-row mt-4`}
          style={{ gap: "20px" }}
        >
          <primaryComponents.TimeInputV2
            control={control}
            name="start_time"
            label="Start Time"
            labelDescription="The time you are starting your service"
            isRequired
            value={
              rootFormDetails?.booking_config?.availability_slots?.start_time
            }
            errorMessage={
              errors?.booking_config?.availability_slots?.start_time
            }
            onKeyUp={() =>
              errors?.booking_config?.availability_slots?.start_time &&
              trigger("booking_config.availability_slots.start_time")
            }
            onChange={({ target: { value } }) => {
              const bookingConfig = { ...rootFormDetails?.booking_config };
              bookingConfig.availability_slots.start_time = value;
              setRootFormDetails((prevState) => ({
                ...prevState,
                booking_config: bookingConfig,
              }));
            }}
          />
          <div className="w-100">
            <primaryComponents.TimeInputV2
              control={control}
              name="end_time"
              label={"End Time"}
              labelDescription="The time you are ending your service"
              isRequired
              value={
                rootFormDetails?.booking_config?.availability_slots?.end_time
              }
              errorMessage={
                errors?.booking_config?.availability_slots?.end_time
              }
              onKeyUp={() =>
                errors?.booking_config?.availability_slots?.end_time &&
                trigger("booking_config.availability_slots.end_time")
              }
              onChange={({ target: { value } }) => {
                const bookingConfig = { ...rootFormDetails?.booking_config };
                bookingConfig.availability_slots.end_time = value;
                setRootFormDetails((prevState) => ({
                  ...prevState,
                  booking_config: bookingConfig,
                }));
              }}
            />

            <primaryComponents.Checkbox
              className="ml-auto mb-1"
              name="endNextDay"
              id={`endNextDay${3322}`}
              isChecked={
                rootFormDetails?.booking_config?.availability_slots
                  ?.ends_next_day
              }
              onChange={() => {
                const bookingConfig = { ...rootFormDetails?.booking_config };
                bookingConfig.availability_slots.ends_next_day =
                  !bookingConfig?.availability_slots?.ends_next_day;
                setRootFormDetails((prevState) => ({
                  ...prevState,
                  booking_config: bookingConfig,
                }));
              }}
            >
              Ends Next Day
            </primaryComponents.Checkbox>
          </div>
        </div>
      </div>
    </section>
  );
};
